var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Facebook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2192_836",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.00012207H16V15.9033H0V0.00012207Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2192_836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.00011C16 3.58217 12.4179 0.00012207 7.99998 0.00012207C3.58205 0.00012207 0 3.58217 0 8.00011C0 11.9928 2.92505 15.3026 6.75009 15.9033V10.3132H4.71831V8.00011H6.75009V6.23722C6.75009 4.23243 7.94486 3.12429 9.77188 3.12429C10.6472 3.12429 11.5629 3.28067 11.5629 3.28067V5.24943H10.5538C9.56038 5.24943 9.24988 5.86595 9.24988 6.49934V8.00011H11.4684L11.114 10.3132H9.24988V15.9033C13.0749 15.3037 16 11.9939 16 8.00011Z",
    fill: "#1977F3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2192_836",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 8,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71826 3.12415H11.5629V16H4.71826V3.12415Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2192_836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.114 10.313L11.4684 7.99996H9.24982V6.49919C9.24982 5.86694 9.55921 5.2493 10.5537 5.2493H11.5629V3.28052C11.5629 3.28052 10.6471 3.12415 9.77184 3.12415C7.94481 3.12415 6.75004 4.23116 6.75004 6.23707V7.99996H4.71826V10.313H6.75004V15.9032C7.15729 15.9673 7.57468 16 7.99993 16C8.4252 16 8.84257 15.9662 9.24982 15.9032V10.313H11.114Z",
    fill: "#FEFEFE"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.af0a136f90d79a4c5593d4f59dd2acd9.svg";
export { ForwardRef as ReactComponent };